import { Button, message, Spin } from 'antd'
import React, { FunctionComponent, useCallback } from 'react'

import { PROPERTY_TYPES } from '../../../common/drmTypes'
import { useCreateAuctionPropertyMutation } from '../../../graphql/generated'
import { useAppSelector } from '../../../redux/hooks'
import { usePropertyDetailTitle } from '../../utils/usePropertyDetailTitle'
import { DetailDrawerPropertyImage } from '../DetailDrawerPropertyImage/DetailDrawerPropertyImage'
import { PropertyDetailFetchError } from '../PropertyDetailFetchError/PropertyDetailFetchError'
import { PropertyDetailSidebarRuian } from '../PropertyDetailSidebarRuian/PropertyDetailSidebarRuian'

interface AuctionMonitoringLinkedPropertyPreviewBoxProps {
  auctionId: string
  propertyId: string
  propertyType: PROPERTY_TYPES
  onCancel: () => void
}

export const AuctionMonitoringLinkedPropertyPreviewBox: FunctionComponent<AuctionMonitoringLinkedPropertyPreviewBoxProps> =
  ({ propertyId, auctionId, propertyType, onCancel }) => {
    const propertyName = usePropertyDetailTitle()
    const { userId, tenantId } = useAppSelector(state => state.myProfile)
    const { data: ruianDetail, fetching } = useAppSelector(
      state => state.property.ruian
    )

    const [, assingProperty] = useCreateAuctionPropertyMutation()

    const handleAssign = useCallback(async () => {
      try {
        await assingProperty({
          auctionProperty: {
            propertyId,
            propertyType,
            auctionId,
            propertyName,
            accountUserId: userId,
            accountId: tenantId,
          },
        })
        message.success('Nemovitost byla přiřazena.')
        onCancel()
      } catch (error) {
        message.error('Chyba při přiřazení nemovitosti.')
      }
    }, [
      assingProperty,
      propertyId,
      propertyType,
      auctionId,
      propertyName,
      userId,
      tenantId,
      onCancel,
    ])

    if (fetching)
      return <Spin className="w-full h-full flex items-center justify-center" />

    if (propertyId === ruianDetail?.id)
      return (
        <div className="mb-4 animate-fadeIn bg-teal-50 p-4 rounded-md border border-gray-300">
          <div className="flex space-x-4">
            <div className="w-2/5 flex flex-col">
              <DetailDrawerPropertyImage
                containerClassName="relative flex flex-1"
                imageClassName="rounded-sm object-cover min-h-full"
                propertyId={propertyId}
                propertyType={propertyType}
              />
            </div>
            <div className="w-3/5 flex flex-col">
              <div className="text-base font-semibold pb-4 mb-4 border-b border-gray-300">
                {propertyName}
              </div>
              <div className="mb-8 flex-1">
                <PropertyDetailSidebarRuian isDrawer />
              </div>
              <div className="flex justify-end space-x-2">
                <Button danger ghost onClick={onCancel}>
                  Zrušit
                </Button>
                <Button type="primary" onClick={handleAssign}>
                  Přiřadit k dražbě
                </Button>
              </div>
            </div>
          </div>
        </div>
      )

    return (
      <PropertyDetailFetchError
        description="Je nám líto, ale nepodařilo se dohledat detailní informace. Zkontrolujte prosím, zda jste vložili správný odkaz."
        message={`${propertyType} nenalezena`}
      />
    )
  }
